import React from 'react';

import {PopupFullPage} from '@/components/Popup';
import TipsAndTutorials from '@/views/TipsAndTutorials/TipsAndTutorials';

import QuickStartGuideConnectionContent from './QuickStartGuideConnectionContent';

const QuickStartGuideDesktop = ({onClose, deviceType}) => {
    return (
        <PopupFullPage
            className='flex h-full'
            // TODO: add headerId
            // aria-labelledby={headerId}
        >
            <QuickStartGuideConnectionContent onClose={onClose} deviceType={deviceType} />
            <TipsAndTutorials isQuickStartGuide onBack={onClose} skipFirstStep deviceType={deviceType} />
        </PopupFullPage>
    );
};

export default QuickStartGuideDesktop;
